export default __webpack_public_path__ + "static/media/paypal.e100c61d.svg";